import api from '@/api'
import store from '@/store'
import utils from '@/utils'
import moment from 'moment';
const FileSaver = require('file-saver')
export default {
  paginate(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/search`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  localAllAudienceData(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/all/local/audience`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  searchAudDataKeyword(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/aud/search/keyword`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  searchKeyword(payload, sort, descending, limit, page) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/search/keyword?limit=${limit}&page=${page}&sortBy=${sort}&descending=${descending}`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllInfluencers(force) {
    return new Promise(function (resolve, reject) {
      const cacheInfluencerList = store.state.cache.influencerList

      if (cacheInfluencerList.data !== null && force === false) {
        resolve(cacheInfluencerList)
      } else {
        api
          .request('get', '/api/v1/influencers?limit=999', true)
          .then(response => {
            if (response.status !== 200) {
              reject(response)
              return
            }

            // Save to Vuex store
            store.commit('SET_INFLUENCERS', response.data)

            resolve(store.state.cache.influencerList)
          })
          .catch(error => {
            // Request failed.
            reject(error)
          })
      }
    })
  },

  async fetchLocalAudienceReport(influencerId, instagramID, instagramHandle, platform = 'instagram') {
    try {
      let report = await api.request('get', `/api/v1/social-data/audience/local/report?instagramID=${instagramID}&instagramHandle=${instagramHandle}&id=${influencerId}&platform=${platform}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  async fetchLocalAudienceReportByAudID(audID, handle, platform = 'instagram') {
    try {
      let report = await api.request('get', `/api/v1/social-data/audience/local/report?audienceID=${audID}&instagramHandle=${handle}&platform=${platform}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  async downloadAudienceReport(reportId, username) {
    try {
      let response = await api.download(`/api/v1/social-data/audience/reports/download/${reportId}`)
      const blob = new Blob([response.data], {
        type: 'application/pdf'
      })
      FileSaver.saveAs(blob, username + '.pdf')
    } catch (error) {
      throw error
    }
  },

  async downloadAudienceReportByInstagramHandle(username, platform) {
    try {
      let response = await api.download(`/api/v1/social-data/audience/reports/pdf/download?handle=${username}&platform=${platform}`)
      const blob = new Blob([response.data], {
        type: 'application/pdf'
      })
      FileSaver.saveAs(blob, username + '_' + platform + '.pdf')
    } catch (error) {
      throw error
    }
  },

  async fetchLookalikeUsers(keyword, platform = 'instagram') {
    try {
      let report = await api.request('get', `/api/v1/social-data/dict/users?keyword=${keyword}&platform=${platform}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  async getUserPosts(instagramID, instagramHandle, keyword) {
    try {
      let report = await api.request('get', `/api/v1/influencers/posts?instagramID=${instagramID}&instagramHandle=${instagramHandle}&keyword=${keyword}`, true)
      if (report.status === 200) {
        return report.data
      }
      throw new Error('Server Error')
    } catch (error) {
      throw error
    }
  },

  async refreshAudienceReport(reportId) {
    try {
      let report = await api.request('get', `/api/v1/social-data/audience/reports/${reportId}`, true)
      return report
    } catch (error) {
      throw error
    }
  },

  exportAllInfluencers() {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/export')
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  exportInfluencersByFilter(influencers) {
    return new Promise(function (resolve, reject) {
      api
        .request('POST', '/api/v1/influencers/export/by/filter', true, influencers)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  exportNonIMSInfluencersByFilter(influencers) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/non-ims/export/by/filter', 'POST', influencers)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `influencers_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  exportAllCampaignPayouts() {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/payments/campaignPayout?fmt=xlsx')
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllCampaignPayouts(filters) {
    const query = utils.func.objectToQueryString(filters)
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/payments/campaignPayout?' + query, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCountries() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/countries', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getInfluencer(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/' + influencerID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getInfluencerCompany(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/' + influencerID + '/companies', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createInfluencer(influencer) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers', true, influencer)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createCampaignPayout(influencerID, campaignPayout) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/' + influencerID + '/campaignPayouts', true, campaignPayout)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editCampaignPayout(id, updateData) {
    const payoutID = id
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/payments/campaignPayout/' + payoutID, true, updateData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editInfluencer(influencer) {
    const influencerID = influencer.id
    delete influencer.id

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/influencers/' + influencerID, true, influencer)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteInfluencer(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/influencers/' + influencerID + '/delete', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  assignCompany(influencerID, companyID) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/' + influencerID + '/companies', true, {
          companyID
        })
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  unassignCompany(influencerID, companyID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/influencers/' + influencerID + '/companies/' + companyID, true)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // search Influencers for all occurence inside database
  searchInfluencers(keyword = '') {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers?keyword=${keyword}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // get Influencer Wordcloud for Admin
  getWordcloud(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/wordcloud/' + influencerID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async validateInfluencer(igHandle) {
    try {
      let url = `https://instagram.com/${igHandle}/?__a=1`
      let resp = await api.request('get', url)
      let data = resp.data
      let user = data.graphql.user
      let influencer = {
        instagramHandle: user.username,
        instagramID: user.id,
        picture: user.profile_pic_url_hd
      }
      return {
        success: true,
        influencer
      }
    } catch (error) {
      return {
        success: false
      }
    }
  },
  getInfluencerDeleteRequests() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/accountDeleteRequest', true)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  accountDeleteRequest(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/accountDeleteRequest', true, payload)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  cancelDeleteRequest(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/influencers/accountDeleteRequest/' + influencerID, true)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  accountDeleteStatus(influencerID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/accountDeleteRequest/' + influencerID, true)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  confirmAccountDeleteRequest(id) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/accountDeleteRequest/confirmDelete/' + id, true)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  importInfluencers(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/influencers/import/byhandles', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  importRateCard(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/influencers/import/rate-card', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getBanks(code) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/banks/${code}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get rate card lists
  getAllRateCards(params) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/influencers/rate-card?' + params, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  saveRateCard(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/influencers-open/rate-card', true, formData)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  saveCreatorCommunity(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/influencers-open/creator-community', true, formData)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Get creator community lists
  getAllCreatorCommunities(params) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/influencers/creator-community?' + params, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadRateCardRpt(influencers) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/rate-card/download', 'POST', influencers)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Ratecard_Forms_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadCreatorCommunityRpt(influencers) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/creator-community/download', 'POST', influencers)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `CreatorCommunity_Forms_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateCreatorCommunityById(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', `/api/v1/influencers/creator-community/${data.id}`, true, data)
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveMutliplePlatforms(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/save/multiple-platforms', true, formData)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  discountPlatforms(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/influencers/disconnect/multiple-platforms', true, formData)
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            resolve(response.data)
            return
          }

          reject(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getAudienceData(handle) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/social-data/audience/influencer/profile?handle=${handle}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getTikTokAudienceData(handle) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/social-data/audience/influencer/tikTok/profile?handle=${handle}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getYoutubeAudienceData(handle) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/social-data/audience/influencer/youtube/profile?handle=${handle}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async searchTopicKeyword(keyword = '') {
    try {
      let report = await api.request('get', `/api/v1/social-data/dict/topic-tags?keyword=${keyword}`, true)
      return report
    } catch (error) {
      throw error
    }
  },
  async searchRelevantKeyword(keyword = '') {
    try {
      let report = await api.request('get', `/api/v1/social-data/dict/relevant-tags?keyword=${keyword}`, true)
      return report
    } catch (error) {
      throw error
    }
  },
  async getPublicProfile(platform, handle) {
    const response = await api.request('post', '/api/v1/social-data/profiles/public', true, { platform, handle });
    return response.data;
  },
  getInfluencerByIgHandle(params) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/handle?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByTikTokHandle(params) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/tiktokhandle?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByYoutubeHandle(params) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/youtubehandle?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByXHSHandle(params) {
    const query = utils.func.objectToQueryString(params)
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/xhsHandle?${query}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByFbHandle(params) {
    const query = utils.func.objectToQueryString(params)
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/fbHandle?${query}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByLinkedInHandle(params) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/linkedinHandle?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getInfluencerByTwitterHandle(params) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/by/twitterHandle?${params}`, true)
        .then(response => {
          if (response.status !== 200) return reject(response)
          resolve(response.data)
        })
        .catch(reject)
    })
  },

  getInfluencerByIds(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/brief-info`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  getInfluencerByHandles(payload) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/brief-info/byhandles`, true, payload)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  saveMergingInf(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/save/merge-inf`, true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async updateInfPlatform(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', `/api/v1/influencers/update/platform`, true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(true)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadSearchCreatorRpt(filters) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/imported/creators', 'POST', filters)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Creators_Search_${moment().format('X')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  downloadAudDataKeyword(filters, limit) {
    filters.export = true
    filters.limit = limit
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/influencers/aud/search/keyword', 'POST', filters)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Creator_Discovery_${moment().format('DD-MM-YYYY')}.xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  checkFollowers(creatorCommunityId) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/influencers/creator-community/check/follower/${creatorCommunityId}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Influencer/influencerAPIs.js